// pages/Portfolio.jsx
import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import './Portfolio.css';
// استيراد صورة الروبوت من مجلد assets
import robotWhatsappIcon from '../assets/robot.png';

const Portfolio = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);

  const translations = {
    ar: {
      hero: {
        badge: "✨ قصص نجاح في التسويق الرقمي",
        titlePart1: "حملات تسويقية ناجحة",
        titlePart2: " ونتائج مذهلة",
        description: "نقدم حلول تسويقية متكاملة تساعد الشركات على النمو والوصول لجمهورها المستهدف بكل احترافية"
      },
      servicesSection: {
        tag: "خدماتنا",
        title: "حلولنا ",
        highlight: "التسويقية"
      },
      services: [
        { icon: '📱', title: 'إدارة السوشيال ميديا', description: 'إدارة احترافية لحساباتك على جميع المنصات', color: '#ff6b35' },
        { icon: '📢', title: 'الإعلانات المدفوعة', description: 'حملات إعلانية مستهدفة على فيسبوك وجوجل', color: '#ff6b35' },
        { icon: '🔍', title: 'تحسين محركات البحث', description: 'تصدر نتائج البحث وزيادة الزيارات', color: '#ff6b35' },
        { icon: '🎨', title: 'تصميم الهوية التجارية', description: 'تصميم شعارات وهويات بصرية احترافية', color: '#ff6b35' },
        { icon: '✍️', title: 'التسويق بالمحتوى', description: 'محتوى إبداعي يجذب ويحول الزوار لعملاء', color: '#ff6b35' },
        { icon: '📊', title: 'تحليلات التسويق', description: 'تقارير وتحليلات دقيقة لقياس الأداء', color: '#ff6b35' }
      ],
      projectsSection: {
        tag: "أعمالنا",
        title: "أحدث ",
        highlight: "المشاريع"
      },
      projects: [
        {
          id: 1,
          title: 'حملة إعلانية على فيسبوك',
          categoryName: 'إعلانات مدفوعة',
          description: 'حملة إعلانية ناجحة على فيسبوك وإنستجرام حققت زيادة 300% في المبيعات خلال شهرين فقط.',
          image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&auto=format&fit=crop',
          metrics: ['+300% مبيعات', '2.5M وصول']
        },
        {
          id: 2,
          title: 'استراتيجية نمو على إنستجرام',
          categoryName: 'سوشيال ميديا',
          description: 'استراتيجية محتوى متكاملة على إنستجرام أدت لزيادة المتابعين من 5K إلى 50K في 6 أشهر.',
          image: 'https://images.unsplash.com/photo-1611262588024-d12430b98920?w=800&auto=format&fit=crop',
          metrics: ['+900% متابعين', '15% تفاعل']
        },
        {
          id: 3,
          title: 'قصة نجاح SEO',
          categoryName: 'تحسين محركات البحث',
          description: 'تحسين موقع إلكتروني ليتصدر نتائج البحث الأولى على جوجل، مما زاد الزيارات بنسبة 450%.',
          image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&auto=format&fit=crop',
          metrics: ['+450% زيارات', 'صفحة أولى جوجل']
        },
        {
          id: 4,
          title: 'مشروع هوية تجارية متكاملة',
          categoryName: 'تصميم الهوية',
          description: 'تصميم هوية بصرية كاملة لشركة ناشئة شملت الشعار، الألوان، والمواد التسويقية.',
          image: 'https://images.unsplash.com/photo-1542744094-3a31f272c490?w=800&auto=format&fit=crop',
          metrics: ['هوية احترافية', '+200% узнаваемость']
        },
        {
          id: 5,
          title: 'حملة تسويق بالمحتوى',
          categoryName: 'تسويق بالمحتوى',
          description: 'استراتيجية محتوى شاملة شملت مقالات، فيديوهات، وإنفوجرافيك حققت 100K زيارة شهرياً.',
          image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&auto=format&fit=crop',
          metrics: ['100K زيارة/شهر', '5K مشترك']
        },
        {
          id: 6,
          title: 'حملة تسويق بالمؤثرين',
          categoryName: 'تسويق بالمؤثرين',
          description: 'حملة تعاون مع 10 مؤثرين في مجال التجميل حققت 5M مشاهدة و+500% زيادة في الطلبات.',
          image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&auto=format&fit=crop',
          metrics: ['5M مشاهدة', '+500% طلبات']
        }
      ]
    },
    en: {
      hero: {
        badge: "✨ Digital Marketing Success Stories",
        titlePart1: "Successful Marketing Campaigns",
        titlePart2: " & Amazing Results",
        description: "We provide integrated marketing solutions to help companies grow and reach their target audience professionally"
      },
      servicesSection: {
        tag: "Our Services",
        title: "Our ",
        highlight: "Marketing Solutions"
      },
      services: [
        { icon: '📱', title: 'Social Media Management', description: 'Professional management of your accounts on all platforms', color: '#ff6b35' },
        { icon: '📢', title: 'Paid Advertising', description: 'Targeted ad campaigns on Facebook and Google', color: '#ff6b35' },
        { icon: '🔍', title: 'SEO', description: 'Top search results and increased traffic', color: '#ff6b35' },
        { icon: '🎨', title: 'Brand Identity Design', description: 'Professional logo and visual identity design', color: '#ff6b35' },
        { icon: '✍️', title: 'Content Marketing', description: 'Creative content that attracts and converts visitors', color: '#ff6b35' },
        { icon: '📊', title: 'Marketing Analytics', description: 'Accurate reports and analytics to measure performance', color: '#ff6b35' }
      ],
      projectsSection: {
        tag: "Our Work",
        title: "Latest ",
        highlight: "Projects"
      },
      projects: [
        {
          id: 1,
          title: 'Facebook Ad Campaign',
          categoryName: 'Paid Ads',
          description: 'Successful Facebook and Instagram ad campaign achieved 300% increase in sales in just 2 months.',
          image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&auto=format&fit=crop',
          metrics: ['+300% Sales', '2.5M Reach']
        },
        {
          id: 2,
          title: 'Instagram Growth Strategy',
          categoryName: 'Social Media',
          description: 'Comprehensive content strategy on Instagram led to follower growth from 5K to 50K in 6 months.',
          image: 'https://images.unsplash.com/photo-1611262588024-d12430b98920?w=800&auto=format&fit=crop',
          metrics: ['+900% Followers', '15% Engagement']
        },
        {
          id: 3,
          title: 'SEO Success Story',
          categoryName: 'SEO',
          description: 'Website optimization to rank first on Google search results, increasing traffic by 450%.',
          image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&auto=format&fit=crop',
          metrics: ['+450% Traffic', 'Google Page 1']
        },
        {
          id: 4,
          title: 'Complete Brand Identity Project',
          categoryName: 'Brand Design',
          description: 'Complete visual identity design for a startup including logo, colors, and marketing materials.',
          image: 'https://images.unsplash.com/photo-1542744094-3a31f272c490?w=800&auto=format&fit=crop',
          metrics: ['Professional Identity', '+200% Recognition']
        },
        {
          id: 5,
          title: 'Content Marketing Campaign',
          categoryName: 'Content Marketing',
          description: 'Comprehensive content strategy including articles, videos, and infographics achieving 100K monthly visits.',
          image: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&auto=format&fit=crop',
          metrics: ['100K Visits/Month', '5K Subscribers']
        },
        {
          id: 6,
          title: 'Influencer Marketing Campaign',
          categoryName: 'Influencer Marketing',
          description: 'Collaboration campaign with 10 beauty influencers achieved 5M views and +500% increase in orders.',
          image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&auto=format&fit=crop',
          metrics: ['5M Views', '+500% Orders']
        }
      ]
    }
  };

  const current = translations[language];

  // يمكنك تغيير رقم الواتساب هنا (بالصيغة الدولية بدون + أو 00)
  const whatsappNumber = "201037334294"; // استبدل برقمك الفعلي
  const whatsappLink = `https://wa.me/${201037334294}`;

  return (
    <div className="portfolio">
      {/* Lang toggle removed */}

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <span>{current.hero.badge}</span>
            </div>
            <h1 className="hero-title">
              {current.hero.titlePart1}
              <span className="gradient-text">{current.hero.titlePart2}</span>
            </h1>
            <p className="hero-description">{current.hero.description}</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">{current.servicesSection.tag}</span>
            <h2 className="section-title">
              {current.servicesSection.title}
              <span className="gradient-text">{current.servicesSection.highlight}</span>
            </h2>
          </div>
          <div className="services-grid">
            {current.services.map((service, index) => (
              <div key={index} className="service-card" style={{ '--service-color': service.color }}>
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="projects">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">{current.projectsSection.tag}</span>
            <h2 className="section-title">
              {current.projectsSection.title}
              <span className="gradient-text">{current.projectsSection.highlight}</span>
            </h2>
          </div>
          <div className="projects-grid">
            {current.projects.map((project) => (
              <div key={project.id} className="project-card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <span className="project-category">{project.categoryName}</span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-metrics">
                    {project.metrics.map((metric, i) => (
                      <span key={i} className="metric">{metric}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Floating WhatsApp Button with custom robot icon */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 1000,
          width: '60px',
          height: '60px',
          transition: 'transform 0.3s ease',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <img
          src={robotWhatsappIcon}
          alt="WhatsApp"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      </a>
    </div>
  );
};

export default Portfolio;